import React, { FC, useState } from 'react'
import { useSiteMetadata } from '../custom-hooks/useSiteMetadata'
import { ContactI, SocialI } from '../types/data-models'

interface ContactComponentI {
  contact: ContactI
  social: SocialI
}
interface WriteToSheetsPayloadI {
  formData: unknown
  spreadsheetId: string
}

interface sendEmailNotificationPayloadI {
  formData: unknown
  emailContacts: unknown
}

const ThankYou: FC = () => (
  <div>
    <p>
      <strong>Thanks for contacting us. We will connect with you soon.</strong>
    </p>
  </div>
)

const SplitContact: FC<ContactComponentI> = ({ contact, social }) => (
  <section className="split contact">
    <section className="alt">
      <h3>Address</h3>
      <p>{contact.address}</p>
    </section>
    <section>
      <h3>Phone</h3>
      <p>
        <a href={`tel:${contact.tel}`}>{contact.tel}</a>
      </p>
    </section>
    <section>
      <h3>Email</h3>
      <p>
        <a href={`mailto:${contact.email}`}>{contact.email}</a>
      </p>
    </section>
    <section>
      <h3>Social</h3>
      <ul className="icons alt">
        {Object.keys(social).map((keyName, i) => (
          <li key={i}>
            <a href={social[keyName as keyof SocialI]} className={`icon fa-${keyName}`} aria-label={keyName}>
              <span className="label">{keyName}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  </section>
)

const ContactForm = () => {
  const {
    spreadsheetId,
    contactFormSheetsAPI,
    contactFormEmailAPI,
    contactFromEmailAddress,
    contactToEmailAddress,
  } = useSiteMetadata()
  const [isSubmissionInProgress, setIsSubmissionInProgress] = useState(false)
  const [isSubmissionSuccess, setIsSubmissionSuccess] = useState(false)

  const writeToSheets = async (payload: WriteToSheetsPayloadI) => {
    let result
    try {
      result = await fetch(contactFormSheetsAPI, {
        method: 'POST',
        body: JSON.stringify(payload),
      })
    } catch (error) {
      console.error('something went wrong', error)
    }
    return result
  }

  const sendEmailNotification = async (payload: sendEmailNotificationPayloadI) => {
    let result
    try {
      result = await fetch(contactFormEmailAPI, {
        method: 'POST',
        body: JSON.stringify(payload),
      })
    } catch (error) {
      console.error('something went wrong', error)
    }
    return result
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onFormSumbit = async (e: any) => {
    e.preventDefault()
    const value = new FormData(e.target)
    const formData = {
      name: value.get('name'),
      email: value.get('email'),
      message: value.get('message'),
    }

    setIsSubmissionInProgress(true)
    const payloadWriteToSheets = { formData: formData, spreadsheetId: spreadsheetId }
    const payloadSendEmailNotification = {
      formData: formData,
      emailContacts: { contactFromEmailAddress, contactToEmailAddress },
    }

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [responseWriteToSheets, responseSendEmailNotification] = await Promise.all([
        writeToSheets(payloadWriteToSheets),
        sendEmailNotification(payloadSendEmailNotification),
      ])
    } catch (error) {
      setIsSubmissionInProgress(false)
    }
    setIsSubmissionInProgress(false)
    setIsSubmissionSuccess(true)
  }

  return (
    <section>
      {isSubmissionSuccess ? (
        <ThankYou />
      ) : (
        <form name="contact" id="contact-form" method="POST" onSubmit={onFormSumbit}>
          <div className="fields">
            <div className="field">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" />
            </div>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input type="email" name="email" id="email" autoComplete="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows={3} />
            </div>
          </div>
          <ul className="actions">
            <li>
              <input type="submit" value="Send Message" disabled={isSubmissionInProgress} />
            </li>
          </ul>
        </form>
      )}
    </section>
  )
}

const Contact: FC<ContactComponentI> = ({ contact, social }) => (
  <React.Fragment>
    <footer className="contact-heading">
      <h2>Contact Us</h2>
      <div id="footer">
        <ContactForm />
        <SplitContact contact={contact} social={social} />
      </div>
    </footer>
  </React.Fragment>
)

export default Contact
